module.exports = "/assets/b3658fb2d9482c50df8996241fb2b67d.png";